/**
 * Cart fabric-by-meter logic - loaded globally so it works in BOTH:
 * - /cart page (full template)
 * - Cart drawer (form loaded via AJAX - our cart.liquid script never runs there!)
 *
 * Uses event delegation (document) so handlers work for dynamically loaded cart.
 */
(function() {
  if (typeof jQuery === 'undefined') return;

  jQuery(function($) {
    // Use event delegation - bound to document, works when cart is loaded into drawer
    $(document).on('click', '.cart-form a.remove[href*="quantity=0"]', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var line = $(this).data('line');
      if (!line) return;
      $(this).closest('.cart-row').addClass('ajaxifyCart--is-loading');
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: { line: line, quantity: 0 },
        dataType: 'json'
      }).then(function() {
        window.location.reload();
      }).fail(function() {
        window.location.href = '/cart/change?line=' + line + '&quantity=0';
      });
    });

    $(document).on('change', '.fabric-meters-variant-select', function() {
      var $select = $(this);
      var newVariantId = $select.val();
      var currentVariantId = $select.data('current-variant-id');
      var line = $select.data('line');
      if (newVariantId === currentVariantId || !newVariantId) return;
      $select.prop('disabled', true);
      // Remove old line FIRST, then add new variant. This avoids line-number
      // confusion when add appends to cart (remove-first keeps indices stable).
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: { line: line, quantity: 0 },
        dataType: 'json'
      }).then(function() {
        return $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: { id: newVariantId, quantity: 1 },
          dataType: 'json'
        });
      }).then(function() {
        window.location.href = '/cart';
      }).fail(function(err) {
        alert(err.responseJSON && err.responseJSON.description ? err.responseJSON.description : 'Error updating cart. Please try again.');
        $select.prop('disabled', false);
      });
    });

    // Sync Total Meters from dropdown when cart appears (cart page or drawer loaded)
    function runMeterSync() {
      $('.fabric-meters-variant-select').each(function() {
        var meters = $(this).find('option:selected').text();
        if (meters) {
          $(this).closest('.cart-row').find('.cart-total-meters-val').text(meters);
        }
      });
    }
    runMeterSync();
    setTimeout(runMeterSync, 100);
    // Re-run when drawer may have loaded (user opens cart ~1-3s after page load)
    setTimeout(runMeterSync, 2000);
  });
})();
